/**
 * OPEN CAMPUS sticky banner display control with session-based suppression.
 *
 * Rules:
 *  - Shown on every page load by default.
 *  - Close (×) : suppress for the rest of the tab session (sessionStorage).
 *  - Banner click : no suppression — banner reappears on next navigation.
 */

const DISMISSED_KEY = 'oc_banner_dismissed';

/**
 * Initialise OPEN CAMPUS banner suppression logic.
 * Should be called after DOMContentLoaded.
 */
export function initOpenCampusBanner() {
    const banner = document.querySelector('.js-oc-banner');
    if (!banner) return;

    // Suppressed for this tab's session (× was clicked earlier in this tab)
    if (sessionStorage.getItem(DISMISSED_KEY)) {
        banner.remove();
        return;
    }

    // Scroll-based visibility
    banner.style.opacity = '0';
    banner.style.bottom = '0';
    banner.style.transition = 'opacity 0.5s ease-in-out, bottom 0.5s ease-in-out';

    const offset = () => window.innerWidth >= 768 ? 50 : 90;

    const showBanner = () => {
        banner.style.opacity = '1';
        banner.style.bottom = `${offset()}px`;
    };

    const hideBanner = () => {
        banner.style.opacity = '0';
        banner.style.bottom = '0';
    };

    const slideThumbnail = document.querySelector('.c-slide-thumbnail');

    if (slideThumbnail) {
        // Home page: show only after .c-slide-thumbnail scrolls out of view
        const handleScroll = () => {
            const rect = slideThumbnail.getBoundingClientRect();
            rect.bottom < 0 ? showBanner() : hideBanner();
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
    } else {
        // Other pages: show immediately
        showBanner();
    }

    // Close button (×): suppress for this tab session and fade out
    const close_btn = banner.querySelector('.js-popup-close');
    if (close_btn) {
        close_btn.addEventListener('click', () => {
            sessionStorage.setItem(DISMISSED_KEY, '1');
            banner.style.transition = 'opacity 0.3s';
            requestAnimationFrame(() => {
                banner.style.opacity = '0';
            });
            setTimeout(() => banner.remove(), 300);
        });
    }
}
